import { useSelector } from 'react-redux';

import { IItem } from '../../interfaces/organizations';
import {
  selectOrganizationDetails,
  selectOrganizationMenuByAlias,
  selectOrganizations,
  selectOrganizationsDetails,
  selectOrganizationsList,
  selectOrganizationsMenu,
  selectOrganizationsTotal,
} from '../selectors/organizations';

export const useOrganizations = () => useSelector(selectOrganizations);
export const useOrganizationsList = () => useSelector(selectOrganizationsList);
export const useOrganizationsDetails = () => useSelector(selectOrganizationsDetails);
export const useOrganizationDetails = (alias: string) => useSelector(selectOrganizationDetails(alias)) || ({} as IItem);
export const useOrganizationsMenu = () => useSelector(selectOrganizationsMenu);
export const useOrganizationMenuByAlias = (alias: string) => useSelector(selectOrganizationMenuByAlias(alias));
export const useOrganizationsTotal = () => useSelector(selectOrganizationsTotal);
